<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2>Recibo</h2>
      </div>
      <div class="col-md-6 text-right">
        <h2>R$ {{ formatMoney(String(data.total)) }}</h2>
      </div>
    </div>
    <div v-for="(item, key) in items" :key="key">
      <p class="worksansr m-0" v-if="item.spent_or_gain == 'CREDITO'">
        Recebi de
        <b>
          {{
            item.spent_or_gain == "CREDITO"
              ? item.finance_client_name
                ? item.finance_client_name
                : "[CLIENTE NÃO INFORMADO]"
              : item.provider_company_name
              ? item.provider_company_name
              : "[FORNECEDOR NÃO INFORMADO]"
          }}</b
        >, a importância de R$ {{ formatMoney(String(item.value)) }} (<b>{{
          handleTextValue(item)
        }}</b
        >), referente o(a): <b> {{ item.description }}</b>
        <b
          class="ml-2"
          v-if="
            item.finance_configuration_category_name &&
            item.finance_configuration_category_name != 'SEM CATEGORIA'
          "
          ><i>({{ item.finance_configuration_category_name }})</i></b
        >
        .
      </p>
      <p class="worksansr m-0" v-if="item.spent_or_gain == 'DEBITO'">
        Recebi de
        <b> {{ user.rest_home_fantasy_name }}</b
        >, a importância de R$ {{ formatMoney(String(item.value)) }} (<b>{{
          handleTextValue(item)
        }}</b
        >), referente o(a): <b> {{ item.description }}</b>
        <b
          class="ml-2"
          v-if="
            item.finance_configuration_category_name &&
            item.finance_configuration_category_name != 'SEM CATEGORIA'
          "
          ><i>({{ item.finance_configuration_category_name }})</i></b
        >
        .
      </p>
      <p class="worksansr m-0">
        Dou plena e geral quitação dos débitos aos quais este recibo se refere.
      </p>
      <p class="worksansr text-right">
        {{
          user.rest_home_uf && user.rest_home_uf.name
            ? user.rest_home_uf.name
            : ""
        }}
        -
        {{
          user.rest_home_uf && user.rest_home_uf.initials
            ? user.rest_home_uf.initials
            : ""
        }},
        <span style="text-decoration: underline"
          >{{ moment(date).format("DD") }}/{{ moment(date).format("MM") }}/{{
            moment(date).format("YYYY")
          }}</span
        >
      </p>
      <p class="worksansr text-right mt-3 mb-0 text-uppercase">
        ___________________________________________
        <br />
        {{
          item.spent_or_gain == "CREDITO"
            ? user.rest_home_fantasy_name
            : item.provider_company_name
            ? item.provider_company_name
            : "[FORNECEDOR NÃO INFORMADO]"
        }}
      </p>
      <p class="worksansr m-0 text-right" v-if="item.spent_or_gain == 'DEBITO'">
        {{ item.provider_cpf_cnpj }}
      </p>
      <hr />
    </div>
    <div class="row">
      <div class="col-md-6 pt-0 pb-0">
        <p class="m-0 worksansr">{{ user.rest_home_fantasy_name }}</p>
        <p class="m-0 worksansr">{{ user.rest_home_cnpj }}</p>
      </div>
      <div class="col-md-6 pt-0 pb-0 text-right">
        <p class="m-0 worksansr">Telefone: {{ user.rest_home_first_phone }}</p>
        <p class="m-0 worksansr">
          {{ user.rest_home_address }}, {{ user.rest_home_num_address }} -
          {{ user.rest_home_neighborhood }} -
          {{
            user.rest_home_uf && user.rest_home_uf.name
              ? user.rest_home_uf.name
              : ""
          }}
        </p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="input-group">
          <div class="input-append">
            <v-btn class="btn-cancel" @click="handleCancel"
              ><i class="fas fa-times mr-2"></i>CANCELAR
            </v-btn>
          </div>
          <input type="date" class="form-control" v-model="date" />
          <select class="form-control" v-model="vias">
            <option value="AMBOS">2 VIAS</option>
            <option value="PAGANTE">1 VIA PAGANTE</option>
            <option value="RECEBENTE">1 VIA RECEBENTE</option>
          </select>
          <div class="input-group-pprend">
            <v-btn class="btn-print" @click="handlePrint">IMPRIMIR</v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatDate,
  formatMoney,
  numbersOnly,
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
} from "../../../../../lib/format";

import extenso from "extenso";

import { userData } from "../../../../../lib/functions";

import moment from "moment";

export default {
  name: "Receipt",
  props: {
    data: Object,
    providers: Array,
    finance_client: Array,
    finance_configuration_account: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },
  data() {
    return {
      items: [],
      vias: "AMBOS",
      date: moment().format("YYYY-MM-DD"),
      user: {},
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    extenso,
    formatDate,
    formatMoney,
    numbersOnly,
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,
    moment,
    handleTextValue(item) {
      let { value } = item;

      value = String(value);

      value = formatMoney(value);

      value = String(value).replace(".", "").replace(".", "");

      return extenso(value, {
        number: { decimalSeparator: "comma" },
        mode: "currency",
        currency: { type: "BRL" },
      });
    },
    retrieve() {
      let { data } = this;

      for (let item of data.items) {
        item.value = numbersOnly(item.value);
      }

      this.items = data.items;

      let { user } = userData();

      this.user = user;
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handlePrint() {
      let { data, vias, date } = this;

      let params = {
        id: data.id,
      };

      let query = {
        vias,
        date,
      };

      let route = this.$router.resolve({
        name: "receipt-print",
        params,
        query,
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>